import React from 'react';
import { IonBackButton, IonButtons, IonCard, IonContent, IonHeader, IonItem, IonLabel, IonList, IonListHeader, IonPage, IonToolbar, withIonLifeCycle } from '@ionic/react';

//	L O C A L I Z A T I O N S


//	S T Y L E

import './sb-info-support.scss';

//	S E R V I C E S

import { service_LocalizationService } from '../../../services/service-localization';
import { service_RestApiService } from '../../../services/service-api';
import { locale___App } from '../../../App.locale';
import { locale___SbInfoSupportPage } from './sb-info-support.locale';

//	C L A S S

class SbInfoSupportPage extends React.Component<{}, {}> {

//#region 																							D E C L A R A T I O N S

	private readonly _LOCALE: service_LocalizationService = new service_LocalizationService();
	private readonly _API: service_RestApiService = new service_RestApiService();

//#endregion

//#region 																							C O N S T R U C T O R

	constructor(
		public props: {},
	) {
		super(props);
	}

//#endregion

//#region 																							R E T U R N

	render() : React.ReactNode {
		return <>
			<IonPage>

				<IonHeader className="ion-no-border" collapse="fade">
					<IonToolbar>
						<IonButtons slot="start">
							<IonBackButton defaultHref="/discover" text={ this._LOCALE.translate(locale___App.ionBackButton___text) }></IonBackButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>

				<IonContent forceOverscroll={ false }>
					<section className="sb-info-support---container">

						<img src="../../assets/ui/icons/icon-helpdesk.svg"/>

						<br />
						<br />

						<IonListHeader>
							<IonLabel style={{textAlign:'center'}}>{ this._LOCALE.translate(locale___SbInfoSupportPage.support___title) }</IonLabel>
						</IonListHeader>

						<br />

						<p>{ this._LOCALE.translate(locale___SbInfoSupportPage.support___paragraph) }</p>
						<p>L'assistenza risponde di solito entro 48 ore</p>

						<br />

						<IonCard>
							<a href="mailto:support@linktomenu.it" target="_blank">
								<IonItem className="is-ion-item-button" button={ true }>
									<i className="fas fa-envelope"></i>
									<IonLabel>support@linktomenu.it</IonLabel>
								</IonItem>
							</a>
						</IonCard>

					{/*

						<br />
						<br />

						<IonListHeader>
							<IonLabel style={{textAlign:'center'}}>Elimina i tuoi dati</IonLabel>
						</IonListHeader>

						<br />

						<IonCard color="danger">
							<IonItem color="danger" className="is-ion-item-button" button={ true } routerLink="/datas/delete-me">
								<i className="fas fa-user-slash"></i>
								<IonLabel>Elimina il tuo account ed i tuoi dati</IonLabel>
							</IonItem>
						</IonCard>

					*/}

					</section>
				</IonContent>

			</IonPage>
		</>;
	}

//#endregion

}

//	E X P O R T

export default withIonLifeCycle(SbInfoSupportPage);